import React from 'react';
import { Box, Button, CircularProgress, Divider } from '@mui/material';

interface ResetActionButtonsProps {
  selectedSEPsCount: number;
  selectedTasksCount: number;
  isResetting: boolean;
  onClearSelection: () => void;
  onReset: () => void;
}

const ResetActionButtons: React.FC<ResetActionButtonsProps> = ({
  selectedSEPsCount,
  selectedTasksCount,
  isResetting,
  onClearSelection,
  onReset,
}) => {
  return (
    <>
      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Button
          variant="outlined"
          onClick={onClearSelection}
          disabled={isResetting}
        >
          Clear Selection
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onReset}
          disabled={
            isResetting ||
            selectedSEPsCount === 0 ||
            selectedTasksCount === 0
          }
          startIcon={isResetting ? <CircularProgress size={20} /> : null}
        >
          {isResetting
            ? 'Processing...'
            : `Reset ${selectedSEPsCount} SEP(s) to Validation Phase`}
        </Button>
      </Box>
    </>
  );
};

export default ResetActionButtons;
